import script from "./CompanyLogoSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLogoSettings.vue?vue&type=script&setup=true&lang=js"

import "./CompanyLogoSettings.vue?vue&type=style&index=0&id=2d14a116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d14a116"]])

export default __exports__